<template>
<div data-app id="app">
  <Modal></Modal>
  <ModalResourceFull></ModalResourceFull>
  <!-- <ModalCargarRecurso></ModalCargarRecurso>
  <ModalRecurso></ModalRecurso>
  <ModalAsignarRecurso></ModalAsignarRecurso> -->
  <!-- <aside v-if="$store.state.modal" class="modal"></aside> -->
  <Header></Header>
  <Main></Main>
  <Footer></Footer>
</div>
</template>

<script>
// import ModalCargarRecurso from "./components/modales/ModalCargarRecurso";
// import ModalRecurso from "./components/modales/ModalRecurso";
// import ModalAsignarRecurso from "./components/modales/ModalAsignarRecurso";

import Modal from "./components/modales/Modal";
import ModalResourceFull from "./components/modales/ModalResourceFull";

import Header from "./components/Header";
import Main from "./components/Main";
import Footer from "./components/Footer";

export default {
  name: "App",

  components: {
    // ModalCargarRecurso,
    // ModalRecurso,
    // ModalAsignarRecurso,
    Modal,
    ModalResourceFull,
    Header,
    Main,
    Footer
  },

  data: () => ({
    //
  })
};

//
</script>
